/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import styles from './styles.scss';

const propTypes = {
  show: React.PropTypes.bool,
};

class SearchFlag extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { show } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
  }

  render() {
    const { show } = this.state;
    return (
      <span className={`halflings halflings-search ${styles.flag} ${show ? styles.show : ''}`} />
    );
  }
}

SearchFlag.propTypes = propTypes;

export default SearchFlag;




// WEBPACK FOOTER //
// ./src/components/SearchFlag/index.jsx